import type { FeatureConfig } from '@platform/client/features';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'resource-center',
      children: [
        {
          path: 'contact-concierge',
          children: [
            {
              index: true,
              lazy: () =>
                import('./contact-concierge/pages/contact-concierge.page'),
            },
            {
              path: 'success', // TODO: This page should not exist
              lazy: () =>
                import(
                  './contact-concierge/pages/contact-concierge-success.page'
                ),
            },
          ],
        },
        {
          path: 'downloads',
          lazy: () => import('./downloads/downloads.page'),
        },
        {
          path: 'allow-list',
          lazy: () => import('./allow-list/pages/allow-list-requirements.page'),
        },
      ],
    },
  ],
  navigation: () => ({
    resources: {
      downloads: {
        title: i18n.t('downloads:pageTitle'),
        segment: '/resource-center/downloads',
      },
      allowlist: {
        title: i18n.t('resourceCenter:allowList.title'),
        segment: '/resource-center/allow-list',
      },
    },
  }),
} satisfies FeatureConfig;
